import script from "./EventList.vue?vue&type=script&setup=true&lang=js"
export * from "./EventList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__